import React, { useState, useEffect } from "react";
import axios from "axios";
import { Trash, Eye } from "../../assets/icons/icons";
import Pagination from "../section/Pagination";
import CustomAlert from "../CustomAlert";

export default function ContactUs() {
  // State for messages, selection, alert and modals
  const [massages, setMassages] = useState([]);
  const [selectedMassages, setSelectedMassages] = useState([]);
  const [alert, setAlert] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState({});
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmAction, setConfirmAction] = useState(null);
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, []);
  // Fetch messages on component mount
  useEffect(() => {
    fetchMassages();
  }, []);

  const fetchMassages = async () => {
    try {
      const response = await axios.get("https://laravel-api.aj-mart.com/api/massages");
      setMassages(response.data.massages);
    } catch (error) {
      console.error("Error fetching messages:", error);
      setAlert({ type: "error", message: "Error fetching messages" });
    }
  };

  // Open the modal to view message details
  const handleViewDetails = (massage) => {
    setViewData(massage);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setViewData({});
  };

  // Delete individual message
  const handleDeleteMassage = async (massage_id) => {
    try {
      await axios.delete(`https://laravel-api.aj-mart.com/api/massages/delete/${massage_id}`);
      setAlert({ type: "success", message: "Message deleted successfully" });
      fetchMassages();
    } catch (error) {
      console.error("Error deleting message:", error);
      setAlert({ type: "error", message: "Error deleting message" });
    }
  };

  // Open confirmation dialog with message and action callback
  const openConfirmDialog = (message, action) => {
    setConfirmMessage(message);
    setConfirmAction(() => action);
    setShowConfirmDialog(true);
  };

  const handleConfirmYes = () => {
    if (confirmAction) confirmAction();
    setShowConfirmDialog(false);
  };

  const handleConfirmNo = () => {
    setShowConfirmDialog(false);
  };

  // Multi-selection: toggle individual selection
  const toggleSelectMassage = (massage_id) => {
    if (selectedMassages.includes(massage_id)) {
      setSelectedMassages(selectedMassages.filter((id) => id !== massage_id));
    } else {
      setSelectedMassages([...selectedMassages, massage_id]);
    }
  };

  // Toggle select all messages
  const toggleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedMassages(massages.map((massage) => massage.massage_id));
    } else {
      setSelectedMassages([]);
    }
  };

  // Delete selected messages
  const handleDeleteSelected = () => {
    if (selectedMassages.length === 0) {
      setAlert({ type: "error", message: "Please select at least one message to delete" });
      return;
    }
    openConfirmDialog("Are you sure you want to delete selected messages?", async () => {
      try {
        for (const id of selectedMassages) {
          await axios.delete(`https://laravel-api.aj-mart.com/api/massages/delete/${id}`);
        }
        setAlert({ type: "success", message: "Selected messages deleted successfully" });
        setSelectedMassages([]);
        fetchMassages();
      } catch (error) {
        console.error("Error deleting selected messages:", error);
        setAlert({ type: "error", message: "Error deleting selected messages" });
      }
    });
  };

  // Helper: truncate long text
  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <section className="py-[25px]">
      {alert && (
        <CustomAlert type={alert.type} message={alert.message} onClose={() => setAlert(null)} />
      )}

      <div className="main-title mb-[20px]">Contact Us</div>
      <div className="flex justify-end items-center gap-[10px] mb-[20px]">
        {selectedMassages.length > 0 && (
          <button
            className="btn bg-red-500 hover:bg-red-600 flex items-center gap-2"
            onClick={handleDeleteSelected}
          >
            <Trash />
            <span>Delete Selected</span>
          </button>
        )}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-200 text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-200 p-[10px]">
                <input
                  type="checkbox"
                  checked={selectedMassages.length === massages.length && massages.length > 0}
                  onChange={toggleSelectAll}
                />
              </th>
              <th className="border border-gray-200 p-[10px]">Client Name</th>
              <th className="border border-gray-200 p-[10px]">Client Email</th>
              <th className="border border-gray-200 p-[10px]">Client Phone</th>
              <th className="border border-gray-200 p-[10px]">Client Message</th>
              <th className="border border-gray-200 p-[10px]">Control Tools</th>
            </tr>
          </thead>
          <tbody>
            {massages.map((massage) => (
              <tr key={massage.massage_id} className="bg-white hover:bg-gray-50">
                <td className="border border-gray-200 p-[10px]">
                  <input
                    type="checkbox"
                    checked={selectedMassages.includes(massage.massage_id)}
                    onChange={() => toggleSelectMassage(massage.massage_id)}
                  />
                </td>
                <td className="border border-gray-200 p-[10px]">{massage.massage_user_name}</td>
                <td className="border border-gray-200 p-[10px]">{massage.massage_user_email}</td>
                <td className="border border-gray-200 p-[10px]">{massage.massage_user_phone}</td>
                <td className="border border-gray-200 p-[10px]">
                  {truncateText(massage.massage_contant, 50)}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  <div className="flex items-center gap-3">
                    <div className="cursor-pointer" onClick={() => handleViewDetails(massage)}>
                      <Eye />
                    </div>
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        openConfirmDialog(
                          "Are you sure you want to delete this message?",
                          () => handleDeleteMassage(massage.massage_id)
                        )
                      }
                    >
                      <Trash />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="py-[25px]">
        <Pagination />
      </div>

      {/* Modal for Viewing Message Details */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[500px] rounded-lg shadow-lg p-[20px] relative">
            <h2 className="text-xl font-bold mb-[10px]">Message Details</h2>
            <div className="flex flex-col gap-[10px]">
              <div className="flex items-center gap-[8px]">
                <div className="text-[#1485a6] font-bold">Client Name :</div>
                <div>{viewData.massage_user_name}</div>
              </div>
              <div className="flex items-center gap-[8px]">
                <div className="text-[#1485a6] font-bold">Client Email :</div>
                <div>{viewData.massage_user_email}</div>
              </div>
              <div className="flex items-center gap-[8px]">
                <div className="text-[#1485a6] font-bold">Client Phone :</div>
                <div>{viewData.massage_user_phone}</div>
              </div>
              <div className="flex items-center gap-[8px]">
                <div className="text-[#1485a6] font-bold">Message Content :</div>
                <div>{viewData.massage_contant}</div>
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-[20px]">
              <button className="btn bg-gray-300 hover:bg-gray-400" onClick={handleCloseModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-[20px] text-center">
            <p className="mb-[20px]">{confirmMessage}</p>
            <div className="flex justify-center gap-4">
              <button className="btn bg-gray-300 hover:bg-gray-400" onClick={handleConfirmNo}>
                No
              </button>
              <button className="btn bg-red-500 hover:bg-red-600" onClick={handleConfirmYes}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
